import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormlyDialogComponent, FormlyDialogData } from 'ng2-app/components/formly-dialog/formly-dialog.component';
import _ from 'lodash';
import { Observable, Subject, finalize, of, switchMap, takeUntil, tap } from 'rxjs';
import { FormlyModel } from 'app/form-core/formly/formly-core.config';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ErcService } from 'app/services/erc/erc.service';
import { DataListItem } from '../erc-custom-smart-values/erc-custom-values-smart.component';
import { ContactState } from 'app/store/contact/contact.state';
import { ErcContact } from 'app/models/dto/erc-contact.model';
import { Select, Store } from '@ngxs/store';
import { ContactRelationship } from 'app/models/dto/contact-relationship.model';

@Component({
  selector: 'app-erc-custom-values-display',
  templateUrl: './erc-custom-values-display.component.html',
  styleUrls: ['./erc-custom-values-display.component.scss'],
  standalone: false
})
export class ErcCustomValuesDisplayComponent implements OnDestroy{
  @Input() dataList: DataListItem[];
  @Input() title: string;
  @Input() toggleTitle: string;
  @Input() displayLimit: number;
  @Input() loading: boolean;
  @Input() ercContacts: ErcContact[];
  @Input() dialogWidth: string;
  @Input() borrowerId: number;
  @Input() convertToFormlyDialogData:
    (
        dataList: DataListItem[],
        formlyDialogDataCallBack: (model: FormlyModel, fields: FormlyFieldConfig[]) => FormlyDialogData
    ) => FormlyDialogData;
  @Input() saveModel: (model: FormlyModel, data: any) => any;
  @Select(ContactState.ercContacts) ercContacts$: Observable<ErcContact[]>;
  @Select(ContactState.contactEmployeeRelationships) contactEmployeeRelationships$: Observable<ContactRelationship[]>;
  @Select(ContactState.contactOwnerRelationships) contactOwnerRelationships$: Observable<ContactRelationship[]>;

  moreDetailsOpen: boolean = false;
  formlyDialogData$: Observable<FormlyDialogData>;
  destroyed$ = new Subject<boolean>();

  constructor(public dialog: MatDialog, public ercService: ErcService, private store: Store) {}

  get dataListHead(): DataListItem[] {
    return this.dataList ? this.dataList.slice(0, this.displayLimit) : [];
  }

  get dataListTail(): DataListItem[] {
    return this.dataList ? this.dataList.slice(this.displayLimit) : [];
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  checkIfArray(data): boolean {
    return !!data && Array.isArray(data);
  }

  checkIfLongText(value): boolean {
    if (value === null || typeof value !== 'string') {
      return false;
    }
    return value.length > 25;
  }

  getAttributeName(label): string {
    return `dl-bv-${_.kebabCase(label)}`;
  }

  handleEdit() {
    this.openDialog(
      this.convertToFormlyDialogData(this.dataList, this.formlyDialogData.bind(this))
      );
  }

  private formlyDialogData(model: FormlyModel, fields: FormlyFieldConfig[]): FormlyDialogData {
    return {
      loading$: of(this.loading),
      title: this.title,
      formlyConfig: {
        model,
        form: new UntypedFormGroup({}),
        fields,
        options: {}
      }
    };
  }

  private openDialog(data: FormlyDialogData) {
    const dialogRef = this.dialog.open(FormlyDialogComponent, {
      data,
      width: this.dialogWidth,
      maxHeight: '100vh',
    });

    dialogRef.componentInstance.saveData.pipe(
      takeUntil(this.destroyed$),
      switchMap((saveData: any) => this.saveModel(saveData.formlyConfig.model, data)),
      tap(() => dialogRef.close()),
    ).subscribe();
  }

}
